import { render, staticRenderFns } from "./ObjectDetailParallax.vue?vue&type=template&id=1b4f9592&scoped=true"
import script from "./ObjectDetailParallax.vue?vue&type=script&lang=js"
export * from "./ObjectDetailParallax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4f9592",
  null
  
)

export default component.exports